module.exports = __webpack_public_path__ + "static/media/ruler-vertical.bcc9dc1a.svg";